type Rules = 'include' | 'exclude'

const filterObjectByKey = <T extends { [key: string]: unknown }, K extends keyof T>(
  obj: T,
  filter: K,
  rule: Rules,
): Partial<T> => {
  const filteredObject = Object.keys(obj)
    .filter((key) => (rule === 'include' ? key === filter : key !== filter))
    .reduce((cur, key) => Object.assign(cur, { [key]: obj[key] }), {} as Partial<T>)

  return filteredObject
}

const filterObjectByKeys = <T extends { [key: string]: unknown }, K extends keyof T>(
  obj: T,
  filters: Array<K>,
  rule: Rules,
): Partial<T> => {
  const filteredObject = Object.keys(obj)
    .filter((key) =>
      filters.some((filter) => (rule === 'include' ? key === filter : key !== filter)),
    )
    .reduce((cur, key) => Object.assign(cur, { [key]: obj[key] }), {} as Partial<T>)

  return filteredObject
}

export { filterObjectByKey, filterObjectByKeys }
